import {
  Component, Input, OnChanges, OnInit, SimpleChanges
} from '@angular/core';
import { AppContext } from '@farris/devkit';
import { ViewElementCollection } from '../common/view';
import { ViewElementService } from '../common/service/view-element.service';

@Component({
  selector: 'lib-render-view',
  templateUrl: './render-view.component.html',
  styleUrls: ['./render-view.component.css']
})
export class RenderViewComponent implements OnInit, OnChanges {

  @Input() appContext: AppContext;

  @Input() renderType: 'entire' | 'partial' = 'entire';

  @Input() componentId;

  public viewElements: ViewElementCollection;

  constructor(private viewElementService: ViewElementService) {
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    const contextChanges = changes.appContext;
    if (contextChanges && contextChanges.previousValue !== contextChanges.currentValue) {
      this.initialize();
    }
  }

  private initialize() {
    // this.appContext = this.context.appContext as AppContext;
    // this.viewElementService.parseMetadataContent(this.appContext.formMetadataContent);
    // this.viewElements = this.viewElementService.getElementByComponentId(this.componentId);
    // if (this.renderType === 'entire') {
    //   this.viewElements = entireViewElements;
    // } else {
    //   const partialViewElements = this.viewElementService.getElementByComponentId(this.componentId);
    //   this.viewElements = partialViewElements;
    // }
    if (this.appContext && this.componentId) {
      this.viewElementService.parseMetadataContent(this.appContext.formMetadataContent);
      this.viewElements = this.viewElementService.getElementByComponentId(this.componentId);
      this.appContext.buildRenderViewContext(this.componentId);
    }
  }
}
